module.exports = __webpack_public_path__ + "static/media/Honduras.b12e0f4d.png";